<div class="flex flex-col gap-16 justify-center items-center h-[100vh] w-full bg-main_color_2/[.02]">
    <div class="w-1/6">
        @if(environment.title.includes('ALG')) {
            <img src="../../../../../assets/img/maintenance-alg.png" alt="Maintenance">
        } @else {
            <img src="../../../../../assets/img/maintenance.png" alt="Maintenance">
        }

    </div>
    <div class="w-1/3 flex flex-col gap-4 text-justify">
        <h1 class="font-bold text-main_color_2 text-3xl">Chers utilisateurs,</h1>
        <div class="flex flex-col gap-2 text-xl">
            <span>Notre application est actuellement en maintenance afin d'améliorer votre expérience et d'assurer un meilleur service. Nous faisons tout notre possible pour terminer cette opération dans les plus brefs délais.</span>
            <span>Nous vous prions de nous excuser pour la gêne occasionnée et vous remercions de votre compréhension et de votre patience.</span>
            <span class="font-semibold">L'application sera de retour très prochainement. Merci pour votre fidélité !</span>
        </div>
        <div class="flex flex-col gap-2 text-xl">
            <span>Cordialement,</span>
            <span>L'équipe de <span class="font-semibold text-main_color">Réseau-Concept</span></span>
        </div>
    </div>
    <a class="absolute right-10 bottom-10" href="https://www.reseau-concept.com/" target="_blank">
        <img src="../../../../../assets/img/logos/logo-reseau-concept-bleu.png" alt="">
    </a>
</div>
